import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-open-in-new",
  templateUrl: "./med-icon-open-in-new.component.html",
  styles: [
  ],
})
export class MedIconOpenInNewComponent extends SvgMixinComponent {}
